import React from 'react';

interface LinkifyProps {
  text: string;
  className?: string;
}

const URL_REGEX = /(https?:\/\/[^\s]+)/gi;

export const linkify = (text: string): (string | React.ReactElement)[] => {
  if (!text) return [''];
  
  const parts = text.split(URL_REGEX);
  
  return parts.map((part, index) => {
    if (URL_REGEX.test(part)) {
      return (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#1976d2',
            textDecoration: 'underline',
            wordBreak: 'break-all',
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {part}
        </a>
      );
    }
    return part;
  });
};

export const Linkify: React.FC<LinkifyProps> = ({ text, className }) => {
  const linkedText = linkify(text);
  
  return (
    <span className={className}>
      {linkedText.map((part, index) => (
        <React.Fragment key={index}>{part}</React.Fragment>
      ))}
    </span>
  );
};

export default Linkify;